export const getBgColor = (index: number): string => {
  if (index % 4 === 0) return '#E8D6D0';
  if (index % 4 === 1) return '#F3ECE4';
  if (index % 4 === 2) return '#EAE7E6';
  if (index % 4 === 3) return '#F3ECE4';
  return '#E8D6D0';
};

export const imageBgColor = 'rgba(249, 247, 250, 1.000)';
